import { AdminTemplate, CardBinAddBulkUploadForm } from "../../components"

export const CardBinAddBulkUpload = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: 'Toplu Kart Bin Tanımı ve Güncelleme',
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true
      }}>
      <CardBinAddBulkUploadForm />
    </AdminTemplate>
  )
}